import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Double requestAnimationFrame ensures the element is painted before adding the open class
    // This is needed for the CSS transition to trigger properly
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.element.classList.add("staff-popout--open")
        document.body.classList.add("overflow-hidden")
      })
    })
  }

  close() {
    this.element.classList.remove("staff-popout--open")
    document.body.classList.remove("overflow-hidden")

    // Wait for CSS transition, then clear the frame
    setTimeout(() => {
      const frame = document.getElementById("staff_member_popout_frame")
      if (frame) {
        frame.innerHTML = ""
      }
    }, 300)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }
}
